<div class="bpaas-content">
  <form [formGroup]="formGroup">
    <p-panel [showHeader]="false">
      <div class="card" #contentElement pBPaaSFocusTrap>
        <div class="grid p-fluid">
          <div class="col-12 md:col-3 lg:col-3">
            <label>文字輸入</label>
            <input type="text" pInputText
              formControlName="detailInput" [id]="parseToId('detailInput')">
          </div>
          <div class="col-12 md:col-3 lg:col-3">
            <label>選擇日期</label>
            <p-calendar [showIcon]="true" appendTo="body"
              formControlName="detailCalendar" dateFormat="yy/mm/dd" dataType="string"
              placeholder="yyyy/mm/dd"
              [showOnFocus]="false"
              [inputId]="parseToId('detailCalendar')">
            </p-calendar>
          </div>
          <div class="col-12 md:col-3 lg:col-3">
            <label>日期區間</label>
            <p-calendar [showIcon]="true" appendTo="body"
              dateFormat="yy/mm/dd" dataType="string"
              selectionMode="range" formControlName="detailCalendarRange"
              [showOnFocus]="false"
              [inputId]="parseToId('detailCalendarRange')">
            </p-calendar>
          </div>
          <div class="col-12 md:col-3 lg:col-3">
            <label>數字輸入</label>
            <p-inputNumber formControlName="detailInputNumber" [inputId]="parseToId('detailInputNumber')"></p-inputNumber>
          </div>
        </div>
        <div class="grid p-fluid">
          <div class="col-12 md:col-3 lg:col-3">
            <label class="bpaas-required">下拉選單 (固定選項)</label>
            <p-dropdown *ngIf="langChangeVisible"
              [options]="exampleOptions"
              placeholder="{{ 'option.please-select' | translate }}" [showClear]="true"
              appendTo="body"
              formControlName="detailDropdown" [inputId]="parseToId('detailDropdown')"
              [ngClass]="{'ng-dirty': formControlInvalid('detailDropdown')}">
            </p-dropdown>
            <div *ngIf="formControlInvalid('detailDropdown')">
              <small class="p-error"
                *ngIf="formControl('detailDropdown').errors?.['required']">
                {{ 'message.validation.required' | translate }}
              </small>
            </div>
          </div>
          <div class="col-12 md:col-3 lg:col-3">
            <label>自動完成</label>
            <p-autoComplete *ngIf="langChangeVisible"
              [suggestions]="exampleDataSuggestions"
              [forceSelection]="true"
              [minLength]="2" [delay]="300" [showClear]="true"
              [showEmptyMessage]="true" emptyMessage="{{ 'table.no-records-found' | translate }}"
              (completeMethod)="searchExampleDataSuggestions($event)"
              (onClear)="autoCompleteCleared('detailAutoCompleteCode')"
              (onFocus)="autoCompleteFocus($event)"
              (onBlur)="autoCompleteBlur($event)"
              (onKeyUp)="autoCompleteKeyUp($event)"
              (onSelect)="autoCompleteCompleted('detailAutoCompleteCode')"
              dataKey="exampleDataCode"
              appendTo="body"
              formControlName="detailAutoCompleteCode" [inputId]="parseToId('detailAutoCompleteCode')"
              field="{{ 'exampleDataName' | translateFieldName: 'exampleDataName' }}">
              <ng-template let-exampleData pTemplate="item">
                {{ exampleData.exampleDataCode }} {{ exampleData.exampleDataName | translateDataValue: exampleData : 'exampleDataName' }}
              </ng-template>
            </p-autoComplete>
          </div>
          <div class="col-12 md:col-3 lg:col-3">
            <label>動態下拉 (資料少適用)</label>
            <p-dropdown *ngIf="langChangeVisible"
              [options]="dynamicOptions"
              optionLabel="{{ 'label' | translateFieldName: 'label' }}"
              optionValue="value"
              placeholder="{{ 'option.please-select' | translate }}" [showClear]="true"
              appendTo="body"
              formControlName="detailDynamicDropdown" [inputId]="parseToId('detailDynamicDropdown')">
            </p-dropdown>
          </div>
          <div class="col-12 md:col-3 lg:col-3">
            <label>自動完成+下拉 (資料少適用)</label>
            <p-autoComplete *ngIf="langChangeVisible"
              [suggestions]="allExampleDataSuggestions"
              [forceSelection]="true"
              [minLength]="2" [delay]="300" [showClear]="true"
              [showEmptyMessage]="true" emptyMessage="{{ 'table.no-records-found' | translate }}"
              (completeMethod)="searchAllExampleDataSuggestions($event)"
              (onClear)="autoCompleteCleared('detailAutoCompleteDropdownCode')"
              (onFocus)="autoCompleteFocus($event)"
              (onBlur)="autoCompleteBlur($event)"
              (onKeyUp)="autoCompleteKeyUp($event)"
              (onSelect)="autoCompleteCompleted('detailAutoCompleteDropdownCode')"
              [dropdown]="true" dropdownMode="blank"
              [completeOnFocus]="false"
              appendTo="body"
              formControlName="detailAutoCompleteDropdownCode" [inputId]="parseToId('detailAutoCompleteDropdownCode')"
              field="{{ 'exampleDataName' | translateFieldName: 'exampleDataName' }}">
              <ng-template let-exampleData pTemplate="item">
                {{ exampleData.exampleDataCode }} {{ exampleData.exampleDataName | translateDataValue: exampleData : 'exampleDataName' }}
              </ng-template>
            </p-autoComplete>
          </div>
        </div>
        <div class="grid p-fluid">
          <div class="col-12 md:col-3 lg:col-3">
            <label>自訂欄位驗證 ( 不能輸入 1 )</label>
            <input type="text" pInputText
              formControlName="detailCustValidation" [id]="parseToId('detailCustValidation')"
              [ngClass]="{'ng-dirty': formControlInvalid('detailCustValidation')}">
            <div *ngIf="formControlInvalid('detailCustValidation')">
              <small class="p-error"
                *ngIf="formControl('detailCustValidation').errors?.['duplicate']">
                {{ 'message.validation.duplicate' | translate }}
              </small>
            </div>
          </div>
        </div>
      </div>
    </p-panel>
  </form>
</div>

<div *ngIf="!masterInViewStatus()" class="bpaas-sticky-footer">
  <button pButton pRipple label="{{ 'button.discard' | translate }}" icon="pi pi-times" class="p-button-text" (click)="discard()" [id]="parseToId('btnDiscard')"></button>
  <button pButton pRipple label="{{ 'button.save' | translate }}" icon="pi pi-check" (click)="save()" [id]="parseToId('btnSave')"></button>
</div>
